module.exports = __webpack_public_path__ + "img/logo.90faf421.png";